// ABOUTME: Mock data for TechLog → Rusada oil uplift transformation testing.
import { TechLogToRusadaOilUpliftInput } from './validation';

/**
 * Twin-engine (Phenom EMB-500) shape: one Veryon oil row per engine position,
 * both configured in quarts, with a TechLog oil uplift for each engine.
 */
export const mockData: TechLogToRusadaOilUpliftInput = {
  techlog: {
    fluidUplifts: [
      {
        id: 'fluid-uplift-lh',
        category: null,
        adjustment: null,
        uplift: 2,
        associatedRecordId: 'sector-123',
        associatedRecordType: 'Flight',
        fluidType: 'oil',
        fluidDestination: 'engine',
        fluidDestinationNumber: 1,
        upliftUnit: 'qt',
        aircraftId: 'aircraft-789',
        initialValue: null,
        departureValue: null,
        hydraulicCircuitId: null,
        attachments: [],
        createdAt: '2026-07-28T09:15:00Z',
        updatedAt: '2026-07-28T09:15:00Z',
      },
      {
        id: 'fluid-uplift-rh',
        category: null,
        adjustment: null,
        uplift: 1.5,
        associatedRecordId: 'sector-123',
        associatedRecordType: 'Flight',
        fluidType: 'oil',
        fluidDestination: 'engine',
        fluidDestinationNumber: 2,
        upliftUnit: 'qt',
        aircraftId: 'aircraft-789',
        initialValue: null,
        departureValue: null,
        hydraulicCircuitId: null,
        attachments: [],
        createdAt: '2026-07-28T09:16:00Z',
        updatedAt: '2026-07-28T09:16:00Z',
      },
    ],
  },
  rusada: {
    flightId: 47395,
    additionalOilAndFuel: [
      {
        id: 0,
        flightId: 47395,
        regJourneyOilAndFuelId: 0,
        locationId: 198,
        locationPositionId: 6,
        modelAttachedModelLocationId: 290,
        regJourneyUpliftTypeId: 6,
        regJourneyUpliftInputId: 1,
        location: '72-00',
        position: 'LH',
        upliftType: 'Engine Oil',
        inputName: 'Before Departure',
        upliftUsage: 0,
        journeyNumber: '1',
        techLogId: 32410,
        journeyCode: '',
        upliftUnitOfMeasureId: 2,
        upliftUnitOfMeasure: 'Oil Quarts',
        maxLimit: 0,
        logBookId: 97,
        assetId: 11087,
        modelUpliftInputMappingId: 13,
      },
      {
        id: 0,
        flightId: 47395,
        regJourneyOilAndFuelId: 0,
        locationId: 198,
        locationPositionId: 5,
        modelAttachedModelLocationId: 291,
        regJourneyUpliftTypeId: 6,
        regJourneyUpliftInputId: 1,
        location: '72-00',
        position: 'RH',
        upliftType: 'Engine Oil',
        inputName: 'Before Departure',
        upliftUsage: 0,
        journeyNumber: '1',
        techLogId: 32410,
        journeyCode: '',
        upliftUnitOfMeasureId: 2,
        upliftUnitOfMeasure: 'Oil Quarts',
        maxLimit: 0,
        logBookId: 98,
        assetId: 11086,
        modelUpliftInputMappingId: 14,
      },
    ],
  },
};
